<template>
    <div class="slider">
        <div id="slider-larg" class="owl-carousel image-gallery">
            <!-- ITEM -->
            <div class="item lightbox-image-icon">
                <a href="images/rooms/single-room/single-room1.jpg" class="hover_effect h_lightbox h_blue">
                    <img class="img-responsive" src="images/rooms/single-room/single-room1.jpg" alt="Image">
                </a>
            </div>
            <!-- ITEM -->
            <div class="item lightbox-image-icon">
                <a href="images/rooms/single-room/single-room2.jpg" class="hover_effect h_lightbox h_blue">
                    <img class="img-responsive" src="images/rooms/single-room/single-room2.jpg" alt="Image">
                </a>
            </div>
            <!-- ITEM -->
            <div class="item lightbox-image-icon">
                <a href="images/rooms/single-room/single-room3.jpg" class="hover_effect h_lightbox h_blue">
                    <img class="img-responsive" src="images/rooms/single-room/single-room3.jpg" alt="Image">
                </a>
            </div>
            <!-- ITEM -->
            <div class="item lightbox-image-icon">
                <a href="images/rooms/single-room/single-room4.jpg" class="hover_effect h_lightbox h_blue">
                    <img class="img-responsive" src="images/rooms/single-room/single-room4.jpg" alt="Image">
                </a>
            </div>
            <!-- ITEM -->
            <div class="item lightbox-image-icon">
                <a href="images/rooms/single-room/single-room5.jpg" class="hover_effect h_lightbox h_blue">
                    <img class="img-responsive" src="images/rooms/single-room/single-room5.jpg" alt="Image">
                </a>
            </div>
            <!-- ITEM -->
            <div class="item lightbox-image-icon">
                <a href="images/rooms/single-room/single-room6.jpg" class="hover_effect h_lightbox h_blue">
                    <img class="img-responsive" src="images/rooms/single-room/single-room6.jpg" alt="Image">
                </a>
            </div>
            <!-- ITEM -->
            <div class="item lightbox-image-icon">
                <a href="images/rooms/single-room/single-room7.jpg" class="hover_effect h_lightbox h_blue">
                    <img class="img-responsive" src="images/rooms/single-room/single-room7.jpg" alt="Image">
                </a>
            </div>
            <!-- ITEM -->
            <div class="item  lightbox-image-icon">
                <a href="images/rooms/single-room/single-room8.jpg" class="hover_effect h_lightbox h_blue">
                    <img class="img-responsive" src="images/rooms/single-room/single-room8.jpg" alt="Image">
                </a>
            </div>
        </div>
        <div id="thumbs" class="owl-carousel">
            <!-- ITEM -->
            <div class="item"><img class="img-responsive" src="images/rooms/single-room/single-room-thumb1.jpg" alt="Image"></div>
            <!-- ITEM -->
            <div class="item"><img class="img-responsive" src="images/rooms/single-room/single-room-thumb2.jpg" alt="Image"></div>
            <!-- ITEM -->
            <div class="item"><img class="img-responsive" src="images/rooms/single-room/single-room-thumb3.jpg" alt="Image"></div>
            <!-- ITEM -->
            <div class="item"><img class="img-responsive" src="images/rooms/single-room/single-room-thumb4.jpg" alt="Image"></div>
            <!-- ITEM -->
            <div class="item"><img class="img-responsive" src="images/rooms/single-room/single-room-thumb5.jpg" alt="Image"></div>
            <!-- ITEM -->
            <div class="item"><img class="img-responsive" src="images/rooms/single-room/single-room-thumb6.jpg" alt="Image"></div>
            <!-- ITEM -->
            <div class="item"><img class="img-responsive" src="images/rooms/single-room/single-room-thumb7.jpg" alt="Image"></div>
            <!-- ITEM -->
            <div class="item"><img class="img-responsive" src="images/rooms/single-room/single-room-thumb8.jpg" alt="Image"></div>
        </div>
    </div>
</template>

<script>
    export default
    {

    }
</script>


// WEBPACK FOOTER //
// slider.vue?16d45ad0